import React, { useState } from 'react';
import { useInstitucion } from '../context/InstitucionContext';

/**
 * Marca de la plataforma PUSAH.
 * - variante "color": para fondos claros (public/logo/pusah.svg).
 * - variante "blanco": sobre los degradados institucionales (public/logo/pusah-blanco.svg).
 * Si la imagen no carga se muestra el nombre de la marca en texto. Cuando la API expone
 * `urlMarca` (Plataforma:UrlMarca) enlaza al sitio de PUSAH; usar conEnlace={false} si ya está
 * dentro de otro enlace, para no anidar <a>.
 */
const MarcaPusah = ({ variante = 'color', className = 'h-6', conEnlace = true }) => {
  const { nombreMarca, urlMarca } = useInstitucion();
  const [sinImagen, setSinImagen] = useState(false);
  const archivo = variante === 'blanco' ? 'pusah-blanco.svg' : 'pusah.svg';

  const contenido = sinImagen ? (
    <span className={`font-extrabold tracking-wider ${variante === 'blanco' ? 'text-white' : 'text-gray-700'}`}>
      {nombreMarca}
    </span>
  ) : (
    <img
      src={`${process.env.PUBLIC_URL}/logo/${archivo}`}
      alt={nombreMarca}
      className={`${className} w-auto`}
      onError={() => setSinImagen(true)}
    />
  );

  if (conEnlace && urlMarca) {
    return (
      <a
        href={urlMarca}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center"
        title={`Ir a ${nombreMarca}`}
      >
        {contenido}
      </a>
    );
  }
  return <span className="inline-flex items-center">{contenido}</span>;
};

export default MarcaPusah;
